import React from 'react';
import PropTypes from 'prop-types';
import { videoPlaylist as playlistPropType } from 'lib/CustomPropTypes';

import Playlist from './Playlist';

import styles from './styles.module.scss';

export const LAYOUT = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

const PlaylistDrawer = ({
  layout,
  nowPlaying,
  onSelect,
  playlists,
  vertical,
}) => (
  <div className={styles.playlistDrawer}>
    {playlists && playlists.map((playlist, index) => (
      <Playlist
        playlist={playlist}
        nowPlaying={nowPlaying}
        layout={layout}
        onSelect={onSelect}
        allowCollapse={layout === LAYOUT.HORIZONTAL}
        collapsedByDefault={index !== 0}
        key={(playlist && playlist.id) || `recommendations${index}`}
        vertical={vertical}
      />
    ))}
  </div>
);

PlaylistDrawer.propTypes = {
  layout: PropTypes.oneOf(Object.values(LAYOUT)),
  playlists: PropTypes.arrayOf(playlistPropType),
  nowPlaying: PropTypes.string,
  onSelect: PropTypes.func,
  vertical: PropTypes.string,
};

PlaylistDrawer.defaultProps = {
  layout: LAYOUT.VERTICAL,
  playlists: [],
  nowPlaying: null,
  onSelect: Function.prototype,
  vertical: null,
};

export default PlaylistDrawer;
